document.addEventListener('DOMContentLoaded', function() {
  var modal = document.getElementById('PdfDownloadModal');
  if (!modal) return;

  var openButtons = document.querySelectorAll('.js-pdf-open-modal');
  var closeButtons = modal.querySelectorAll('.js-pdf-close-modal');
  var form = modal.querySelector('.js-pdf-form');
  var errorEl = modal.querySelector('.js-pdf-error');
  var successEl = modal.querySelector('.js-pdf-success');
  var downloadBtn = modal.querySelector('.js-pdf-download');

  function openModal(pdfUrl) {
    if (downloadBtn) {
      downloadBtn.setAttribute('href', pdfUrl || '#');
    }

    form.reset();
    form.hidden = false;
    errorEl.hidden = true;
    successEl.hidden = true;

    modal.classList.add('is-active');
    document.documentElement.classList.add('pdf-modal-open');
    document.body.classList.add('pdf-modal-open');
  }

  openButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openModal(btn.getAttribute('data-pdf-url') || btn.getAttribute('href'));
    });
  });

  closeButtons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      modal.classList.remove('is-active');
      document.documentElement.classList.remove('pdf-modal-open');
      document.body.classList.remove('pdf-modal-open');
    });
  });

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var first = form.querySelector('input[name="contact[first_name]"]').value.trim();
    var last = form.querySelector('input[name="contact[last_name]"]').value.trim();
    var email = form.querySelector('input[name="contact[email]"]').value.trim();

    if (!first || !last || !email || email.indexOf('@') < 0) {
      errorEl.textContent = 'Please complete all fields correctly.';
      errorEl.hidden = false;
      return false;
    }

    form.hidden = true;
    successEl.hidden = false;

    return false;
  });
});